import { FC, PropsWithChildren, ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { User } from '@services';
import { useLoggedinUser } from '@hooks';
import { PortalRoutePath, getPortalRoute } from '@models';
import { LoadingLayout } from '@components/common';

export interface IGuardedPageProps {
	canActivate: (user: User) => boolean;
	redirectTo?: string;
	loadingComponent?: ReactNode;
	loading?: boolean;
}

export const GuardedPage: FC<PropsWithChildren<IGuardedPageProps>> = ({ canActivate, redirectTo, children, loadingComponent, loading }) => {
	const user = useLoggedinUser();

	if (!user || loading) {
		return <>{loadingComponent ? loadingComponent : <LoadingLayout />}</>;
	} else {
		if (!canActivate(user)) {
			return <Navigate to={redirectTo || getPortalRoute(PortalRoutePath.WELCOME)} />;
		} else {
			return <>{children}</>;
		}
	}
};
